import { toast } from "react-toastify";
function handleErrorCallback(error) {
  try {
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors[0] &&
      error?.response?.data?.errors[0]?.code === "error" &&
      error?.response?.data?.errors[0]?.detail?.indexOf("duplicate") >= 0
    ) {
      return;
    }
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors[0] &&
      error?.response?.data?.errors[0]?.code !== "unique" &&
      error?.response?.data?.errors[0]?.attr !== "push_service_token"
    ) {
      toast.error(error?.response?.data?.errors[0]?.detail);
    }
  } catch (e) {}
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errors &&
    error.response.data.errors[0] &&
    error?.response?.data?.errors[0]?.code ===
      "permission_denied_user_not_validated"
  ) {
    window.location.href = "/account-info?state=auth";
  }
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errors &&
    error.response.data.errors[0] &&
    error?.response?.data?.errors[0]?.code ===
      "permission_denied_bank_account_not_validated"
  ) {
    window.location.href = "/addcard";
  }
}
export default handleErrorCallback;
